module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I retreated into the dining room in back of the terrace, and began hurriedly to check the tables, polishing a knife here, adjusting a glass there. I checked that the wines were cooling, checked that the linen napkins were properly folded, checked my long ginger hair in the mirror behind the bar, wishing I could call it copper or even red, but ginger it was. I wished one more time that I had exotic almond-shaped eyes instead of my too-round ones, wished I knew a recipe to get rid of freckles, that I was taller and leaner and maybe ten years younger. I was thirty-nine years old and after the events of the past six months, I decided gloomily, I looked every year of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wasn’t exactly into a glamorous mode either, in my baggy houndstooth chef’s pants and shrunken white tee, with no lipstick and, even worse, no mascara on my ginger-cat lashes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Horrified, I realized I was looking at exactly what the Naked Man had seen through the binoculars. I thought worriedly I really must make more effort but that anyhow he certainly wasn’t interested in me; then I forgot about him and headed for my true domain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The jewel-colored bead door curtain jangled behind me and I was in my favorite place in the whole world, my big tile-floored kitchen with ancient beams and a row of open windows overhung with blossoming vines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’d known the first day I saw it, this had to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" kitchen. It had stolen my chef’s heart even more than the magical view from the terrace and the sandy winding paths, the shady pines and the wild overgrown gardens. More than the cool upstairs rooms with their tall windows and lopsided shutters, and the downstairs “salon” with its imposing limestone fireplace that was far too grand for such a humble seaside villa. More than any of that, this kitchen was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("home")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was the place where I could put all thoughts of sophisticated city restaurants behind me and get back to my true foodie roots, back to the simple pleasures of local produce and seasonally grown fruits and vegetables. Here, I would grill fish that swam almost at the bottom of my garden and pick the herbs that grew almost wild to flavor my dishes. I knew I could relax and be myself in this place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It all seemed so perfect. But first “true love” disappeared; then Patrick had disappeared, and now my only love left was my little hotel. Oh, and Scramble, whom I’ll tell you about later.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My private life might be a mess, but all was well in my culinary world. Sauces simmered on the stove; fishes shone silver and bright-eyed in the glass-fronted refrigerated drawer; perfect little racks of Sisteron lamb awaited a hot oven, and individual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tians")]), _vm._v(" of eggplant and tomatoes were drizzled with succulent olive oil from Nice, ready to be popped into the oven.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fifteen-foot pine table stood under the windows. On it a couple of tartes Tatin cooled alongside a big blue bowl of sliced ripe peaches marinating in vermouth. Next to them were the spun-sugar cage confections, a remnant of my old “grand” restaurant days and with which I liked to top my desserts, because I enjoy the delighted oohs and aahs they evoke from my guests. Oh, and as always, a tray of my signature nut-topped brownies, my American specialty that I like to serve with the coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You’ll find no huge white plates centered with tiny “culinary arrangements” here. Our food is simple but lavish, our plates are locally made stoneware, the color of good honey, and we garnish them with only fresh flowers and a sprig of herbs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I dropped a kiss on my assistant Nadine’s cheek in passing. She’s been with me since the beginning, all traumatic six years, and I love her to pieces. She’s a local woman, dark-haired, dark-eyed, olive-skinned, with a raucous laugh and a sense of humor that’s gotten us through many a kitchen disaster. Along with her sister, she takes care of the housekeeping as well as helping in the kitchen, while I deal with the food, the marketing, the menus, and the cooking; and Patrick supposedly took care of the business end, though from our meager bank account, I’m not sure how good a job he had been doing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Petite dark-haired Marit, straight out of culinary school and a new recruit this season, was chopping vegetables, and Jean-Paul, the seventeen-year-old “youth-of-all-work” was busy cleaning up. The real season was over; it would be an easy night with just the remaining hotel guests and perhaps a couple of last-minute strays who might wander our way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I slid a Barry White album, my current favorite sexy man, into the CD player, grabbed a brownie, pushed my way back through the jangling beads, and came across Scramble. Okay, so Scramble’s not a dog, she’s not a cat, or even a hamster. Scramble is a hen. I know it’s crazy, but ever since she emerged from the shell, a soft fluffy yellow chicken cradled trustingly in the palm of my hand, I’ve adored her, and I’d like to believe she loves me too, though with a hen it’s hard to tell. Anyhow, the fact is I’m the only woman who cried the whole way through "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicken Run")]), _vm._v(". And though you might think it’s a sad state of affairs, giving all my love to a hen instead of a husband, Scramble deserves it more. She’s never unfaithful, she never even glances at anybody else, and she sleeps in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" bed every night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s quite big now, soft and white with yellow legs, ruby crest and wattles, and beady dark eyes. She’s scratching energetically in the big terra-cotta pot with the red hibiscus outside the kitchen door that she’s claimed as home, preparing to settle down for the night, or at least until I go to bed when she’ll join me on my pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I gave her an affectionate little pat as I passed by, which she returned with a hearty peck. “Ungrateful bird,” I said. “I remember when you were just an egg.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I cast a cautious glance at the black sloop as I walked back along the terrace. Lights twinkled and banners fluttered festively. I wondered what the Naked Man was up to, and whether he might row the boat’s little dinghy into my cove and join us for dinner on the terrace.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I sighed. I wasn’t betting on it.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7c9c1c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312308094_ch02.vue
// module id = 72
// module chunks = 0